import { gql } from '@apollo/client';

export const DELETE_COMMUNITY_ACTION = gql`
  mutation DeleteCommunityAction($communityId: ID!, $actionName: String!) {
    deleteCommunityAction(communityId: $communityId, actionName: $actionName)
  }
`;
